export default __webpack_public_path__ + "static/media/Cartero-Regular.76b980e9.ttf";